import styled from '@mint-lib/styled';

import Box, { Props } from '../Box/Box.jsx';

export interface FilterSearchContainerProps extends Props {
  disabled?: boolean;
}

const FilterSearchContainer = ({
  children,
  disabled,
  ...props
}: FilterSearchContainerProps) => {
  return (
    <StyledFilterSearchContainer {...props} disabled={disabled}>
      {children}
    </StyledFilterSearchContainer>
  );
};

export default FilterSearchContainer;

export const StyledFilterSearchContainer = styled(Box)<{
  disabled?: boolean;
}>(({ theme, disabled }) => ({
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
  paddingRight: '0.5rem',
  border: `1px solid ${theme.palette.ui.tertiary}`,
  borderRadius: '0.5rem',
  gap: '0.25rem',
  backgroundColor: theme.palette.ui.field02,
  boxShadow: disabled ? 'none' : '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
}));
